import { elMb5 } from '@reapit/elements'
import { usePlatformGet } from '@reapitform/hooks'
import { IFormCardResponseData } from '@reapitform/common-ui'
import { Card, CardBodySectionWrapper, CardBodyWrapper, LoadingSkeleton } from '@reapitform/common-ui'
import { FormContentCard } from './form-content-card'
import React from 'react'

export interface IRenderFormCardProps {
  stepId: string
  cardId: string
  recipientId: string
}

export const CardLoading: React.FC = () => {
  return (
    <Card role="progressbar">
      <LoadingSkeleton className={elMb5} height="1.5rem" />
      <CardBodyWrapper>
        <CardBodySectionWrapper style={{ gap: '0.25rem' }}>
          <LoadingSkeleton height="1.25rem" />
          <LoadingSkeleton height="1.25rem" width="75%" />
        </CardBodySectionWrapper>
        <CardBodySectionWrapper style={{ gap: '0.25rem' }}>
          <LoadingSkeleton />
          <LoadingSkeleton />
          <LoadingSkeleton width="75%" />
        </CardBodySectionWrapper>
        <CardBodySectionWrapper style={{ gap: '0.25rem' }}>
          <LoadingSkeleton />
          <LoadingSkeleton width="75%" />
        </CardBodySectionWrapper>
      </CardBodyWrapper>
    </Card>
  )
}

export const RenderFormCard: React.FC<IRenderFormCardProps> = ({ stepId, cardId, recipientId }) => {
  const [result, loading, errorString] = usePlatformGet<IFormCardResponseData>({
    path: `/api/recipient/${recipientId}/Card`,
    queryParams: {
      step: stepId,
      cardNum: cardId,
    },
    retry: false,
    isProtectedRoute: false,
    headers: { accept: 'application/json' },
  })

  if (loading) return <CardLoading />
  if (errorString) {
    console.error('Err: Failed to fetch the card data!')
    return null
  }

  return (
    <FormContentCard
      cardId={cardId}
      iconName={result?.cardIcon}
      headingText={result?.cardDisplayName}
      bodyTitle={result?.cardDisplayDataHeading}
      bodyContent={result?.cardDisplayDataBody}
      bodyAdditionalContent={result?.cardDisplayDataAdditional}
    />
  )
}
